import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../css/calender.css";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import imgCalender from "../images/crbt5.png";

const localizer = momentLocalizer(moment);

const CustomToolbar = ({ label, view, views, onView, onNavigate }) => {
  const buttonStyle = {
    backgroundColor: "#0C4876",
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const leftMargin = windowWidth < 768 ? 50 : 5; // 왼쪽 마진을 5px 또는 10px로 설정
  const rightMargin = windowWidth < 768 ? 50 : 5; // 오른쪽 마진을 5px 또는 10px로 설정

  const todayStyle = {
    backgroundColor: "#0C4876",
    marginLeft: leftMargin,
    marginRight: rightMargin,
  };
  return (
    <div className="custom-toolbar">
      <div className="custom-toolbar-navigation">
        <button style={buttonStyle} onClick={() => onNavigate("PREV")}>
          before
        </button>
        <button style={todayStyle} onClick={() => onNavigate("TODAY")}>
          today
        </button>
        <button style={buttonStyle} onClick={() => onNavigate("NEXT")}>
          next
        </button>
      </div>
      <div className="custom-toolbar-label">{label}</div>
      <div className="custom-toolbar-views">
        {views.map((viewOption) => (
          <button
            key={viewOption}
            className={view === viewOption ? "active" : ""}
            onClick={() => onView(viewOption)}
          >
            {viewOption}
          </button>
        ))}
      </div>
    </div>
  );
};

const TimeSlotCalendar = ({ onSlotSelect }) => {
  const [selectedSlot, setSelectedSlot] = useState([]);
  const [events, setEvents] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null); // 추가
  const open = Boolean(anchorEl);
  const [selectedEventInfo, setSelectedEventInfo] = useState(null);
  const apiUrl = process.env.REACT_APP_API;

  // 바 클릭 시 Popover 열기
  const handleBarClick = (e, event) => {
    setAnchorEl(event.target);
    setSelectedEventInfo(e);
  };
  // Popover 닫기
  const handleClosePopover = () => {
    setAnchorEl(null);
    setSelectedEventInfo(null); // 팝오버 닫을 때 선택한 바 정보 초기화
  };

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(`${apiUrl}/mr/calender`, requestOptions)
      .then((response) => response.json())
      .then((res) => {
        const newEvents = res.map((eventData) => ({
          id: eventData.reservationSid,
          title: eventData.reservationSubject,
          start: new Date(eventData.reservationStartTime),
          end: new Date(eventData.reservationEndTime),
          create: new Date(eventData.createdTime),
          phone: eventData.reservationPhone,
          part: eventData.reservationPart,
          name: eventData.reservationName,
          yn2: eventData.executiveFlag,
          yn: eventData.approveFlag,
          num: eventData.roomSid,
          noteyn: eventData.notebookFlag,
          beamyn: eventData.beamFlag,
        }));

        // 기존 이벤트 배열과 새로운 이벤트 배열을 합칩니다.
        setEvents(newEvents);
      });
  }, []);

  const approve = (sid) => {
    fetch(`${apiUrl}/mr/approve?sid=${sid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // 서버 응답을 JSON으로 파싱
      })
      .then((responseData) => {
        const newEvents = responseData.map((eventData) => ({
          id: eventData.reservationSid,
          title: eventData.reservationSubject,
          start: new Date(eventData.reservationStartTime),
          end: new Date(eventData.reservationEndTime),
          create: new Date(eventData.createdTime),
          phone: eventData.reservationPhone,
          part: eventData.reservationPart,
          name: eventData.reservationName,
          yn2: eventData.executiveFlag,
          yn: eventData.approveFlag,
          num: eventData.roomSid,
          noteyn: eventData.notebookFlag,
          beamyn: eventData.beamFlag,
        }));
        setEvents(newEvents);
        handleClosePopover();
      })
      .catch((error) => {
        // 오류 처리 (네트워크 오류 또는 서버 오류 등)
        console.error("Error:", error);
      });
  };

  const refuse = (sid) => {
    fetch(`${apiUrl}/mr/refuse?sid=${sid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // 서버 응답을 JSON으로 파싱
      })
      .then((responseData) => {
        // 성공적인 응답 처리
        const newEvents = responseData.map((eventData) => ({
          id: eventData.reservationSid,
          title: eventData.reservationSubject,
          start: new Date(eventData.reservationStartTime),
          end: new Date(eventData.reservationEndTime),
          create: new Date(eventData.createdTime),
          phone: eventData.reservationPhone,
          part: eventData.reservationPart,
          name: eventData.reservationName,
          yn2: eventData.executiveFlag,
          yn: eventData.approveFlag,
          num: eventData.roomSid,
          noteyn: eventData.notebookFlag,
          beamyn: eventData.beamFlag,
        }));
        setEvents(newEvents);
        handleClosePopover();
      })
      .catch((error) => {
        // 오류 처리 (네트워크 오류 또는 서버 오류 등)
        console.error("Error:", error);
      });
  };

  const wait = (sid) => {
    fetch(`${apiUrl}/mr/wait?sid=${sid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // 서버 응답을 JSON으로 파싱
      })
      .then((responseData) => {
        // 성공적인 응답 처리
        const newEvents = responseData.map((eventData) => ({
          id: eventData.reservationSid,
          title: eventData.reservationSubject,
          start: new Date(eventData.reservationStartTime),
          end: new Date(eventData.reservationEndTime),
          create: new Date(eventData.createdTime),
          phone: eventData.reservationPhone,
          part: eventData.reservationPart,
          name: eventData.reservationName,
          yn2: eventData.executiveFlag,
          yn: eventData.approveFlag,
          num: eventData.roomSid,
          noteyn: eventData.notebookFlag,
          beamyn: eventData.beamFlag,
        }));
        setEvents(newEvents);
        handleClosePopover();
      })
      .catch((error) => {
        // 오류 처리 (네트워크 오류 또는 서버 오류 등)
        console.error("Error:", error);
      });
  };
  const handleSlotSelect = (slotInfo) => {
    setSelectedSlot(slotInfo);
    const startDate = moment(slotInfo.start).format("YYYY-MM-DD");
    const endDate = moment(slotInfo.end).format("YYYY-MM-DD");

    // 시작날짜와 종료날짜를 사용하여 fetch 요청 보내기

    fetch(`${apiUrl}/mr/meeting?start=${startDate}&end=${endDate}`)
      .then((response) => response.json())
      .then((res) => {
        onSlotSelect(res);

        // JSON 데이터가 배열 안에 있는 경우, 각 객체에 대해 이벤트를 생성합니다.
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        // 오류 처리 로직 추가
      });
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const eventStyleGetter = (event2, start, end, isSelected) => {
    // 이벤트에 대한 스타일을 설정합니다.
    const style = {
      backgroundColor:
        event2.yn === "A"
          ? event2.num === 1
            ? "#C995A2"
            : event2.num === 2
            ? "#5D7599"
            : "#FCA805"
          : //"#5D7599"
          event2.yn === "N"
          ? "#FB3C04"
          : "#3FAD98", // 배경색
      color: "white", // 텍스트 색상
      fontSize: windowWidth < 768 ? "10px" : "12px",
    };

    return {
      style,
    };
  };

  const calendarStyle = {
    height: windowWidth < 768 ? "500px" : "750px",
  };
  const calendarMargin = {
    margin: windowWidth < 768 ? "5px" : "10px",
    fontSize: windowWidth < 768 ? "10px" : "16px",
  };
  return (
    <div style={calendarStyle}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={calendarMargin}
        eventPropGetter={eventStyleGetter}
        components={{
          toolbar: CustomToolbar,
        }}
        selectable
        onSelectSlot={(slotInfo) => {
          handleSlotSelect(slotInfo);
        }}
        onSelectEvent={(e, event) => {
          handleBarClick(e, event);
        }}
        dayPropGetter={(date) => {
          if (
            selectedSlot &&
            date >= selectedSlot.start &&
            date < selectedSlot.end
          ) {
            return { style: { backgroundColor: "lightblue" } }; // 선택된 슬롯 배경색 변경
          }
          return {};
        }}
      />
      <div className="imgCalender">
        <img src={imgCalender} />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom", // Popover의 원점이 되는 수직 위치 (bottom: 아래)
          horizontal: "right", // Popover의 원점이 되는 수평 위치 (right: 오른쪽)
        }}
      >
        {selectedEventInfo ? (
          <div>
            <Typography sx={{ p: 2, fontSize: 14, paddingBottom: 1 }}>
              시작: {moment(selectedEventInfo.start).format("YYYY-MM-DD HH:mm")}
              <br />
              종료: {moment(selectedEventInfo.end).format("YYYY-MM-DD HH:mm")}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              회의실:{" "}
              {selectedEventInfo.num === 1
                ? "T1 2F 교육장"
                : selectedEventInfo.num === 2
                ? "T2 2F 대회의실"
                : "T2 3F 대회의실"}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              번호: {selectedEventInfo.phone}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              사유: {selectedEventInfo.title}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              부서: {selectedEventInfo.part}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              담당자: {selectedEventInfo.name}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              임원참석여부: {selectedEventInfo.yn2}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              노트북사용여부: {selectedEventInfo.noteyn}
            </Typography>
            <Typography sx={{ paddingLeft: 2, fontSize: 14, paddingBottom: 1 }}>
              빔프로젝트사용여부: {selectedEventInfo.beamyn}
            </Typography>
            {sessionStorage.getItem("id") === "AACTHR" || "AACTIT" ? (
              <Button
                sx={{ p: 0.5, fontSize: 12 }}
                onClick={(e) => {
                  e.stopPropagation(); // 이벤트 버블링 중단
                  approve(selectedEventInfo.id);
                }}
                variant="text"
              >
                승인하기
              </Button>
            ) : (
              <div></div>
            )}
            {sessionStorage.getItem("id") === "AACTHR" || "AACTIT" ? (
              <Button
                sx={{ p: 0.5, fontSize: 12 }}
                onClick={(e) => {
                  e.stopPropagation(); // 이벤트 버블링 중단
                  refuse(selectedEventInfo.id);
                }}
                variant="text"
              >
                승인거부
              </Button>
            ) : (
              <div></div>
            )}
            {sessionStorage.getItem("id") === "AACTHR" || "AACTIT" ? (
              <Button
                sx={{ p: 0.5, fontSize: 12 }}
                onClick={(e) => {
                  e.stopPropagation(); // 이벤트 버블링 중단
                  wait(selectedEventInfo.id);
                }}
                variant="text"
              >
                대기
              </Button>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <Typography sx={{ p: 2 }}>선택된 이벤트 정보가 없습니다.</Typography>
        )}
      </Popover>
    </div>
  );
};
export default TimeSlotCalendar;
